import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="webp" transform="translate(-565 -298)">
        <g id="file-extension" transform="translate(565 298)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#a6cc73"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#567132"
          />
          <path
            id="Контур_814"
            data-name="Контур 814"
            d="M2.977-1.36l.4-2.195h.837l-.743,3.5H2.6l-.469-2-.459,2H.8l-.745-3.5H.89l.4,2.195.481-2.195h.716Zm3.886-.178H5.536V-.7H7.1v.649H4.692v-3.5H7.108V-2.9H5.536v.738H6.862ZM7.594-.055v-3.5H8.851a1.78,1.78,0,0,1,1.028.248.824.824,0,0,1,.352.719.833.833,0,0,1-.125.464.728.728,0,0,1-.368.284.738.738,0,0,1,.421.269.783.783,0,0,1,.147.481.927.927,0,0,1-.326.773,1.55,1.55,0,0,1-.965.263Zm.844-1.488V-.7h.553a.526.526,0,0,0,.351-.1A.366.366,0,0,0,9.464-1.1a.388.388,0,0,0-.435-.44Zm0-.553h.44a.626.626,0,0,0,.394-.1.358.358,0,0,0,.118-.291.376.376,0,0,0-.127-.319.683.683,0,0,0-.411-.1H8.438Zm3.323.853V-.055h-.844v-3.5h1.4a1.627,1.627,0,0,1,.71.148,1.114,1.114,0,0,1,.478.421,1.149,1.149,0,0,1,.169.619,1.013,1.013,0,0,1-.367.819,1.521,1.521,0,0,1-1.006.306Zm0-.651h.553a.521.521,0,0,0,.374-.123.455.455,0,0,0,.129-.346.563.563,0,0,0-.132-.392.468.468,0,0,0-.361-.149h-.562Z"
            transform="translate(2.763 14.555)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
